<template>
  <div>
    <!-------------------------------------------TOOLBAR------------------------------------------->
    <toolbar />
    <!--------------------------------------------TABS--------------------------------------------->
    <v-row v-if="loading" align-center justify-center ma-4>
      <v-progress-circular :size="80" color="red-darken-3" indeterminate />
    </v-row>

    <v-card v-else flat>
      <v-tabs v-model="active" color="black" slider-color="red-darken-3">
        <v-tab v-for="(item, index) in visibleTabs" :key="index" :value="item.value">
          {{ item.title }}
        </v-tab>
      </v-tabs>

      <v-window v-model="active">
        <v-window-item
          v-for="(item, index) in visibleTabs"
          :key="index"
          :value="item.value"
        >
          <v-card flat>
            <v-card-text v-if="item.value === 'general'">
              <general ref="generalTab" :institution="institution" />
            </v-card-text>

            <v-card-text v-else-if="item.value === 'products'">
              <products :institution="institution" />
            </v-card-text>

            <v-card-text v-else-if="item.value === 'whatsAppChatBot'">
              <whatsapp :institution="institution" />
            </v-card-text>

            <v-card-text v-else-if="item.value === 'whatsappBusiness'">
              <whatsapp-settings :institution="institution" />
            </v-card-text>

            <v-card-text v-else-if="item.value === 'payments'">
              <payment :institution="institution" />
            </v-card-text>

            <v-card-text v-else-if="item.value === 'plates'">
              <plates :institution="institution" />
            </v-card-text>

            <v-card-text v-else-if="item.value === 'optIn'">
              <optIn :institution="institution" />
            </v-card-text>

            <v-card-text v-else-if="item.value === 'twoFactorAuth'">
              <twoFactorAuth :institution="institution" />
            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>
      <v-card-actions class="pl-6 pr-6 mb-8">
        <v-btn
          v-if="active !== 'whatsappBusiness'"
          variant="flat"
          color="success"
          :loading="loadingSave"
          outlined
          @click="save"
        >
          {{ $t("settings.save") }}
        </v-btn>
        <v-spacer />
        <v-btn variant="outlined" color="primary" @click="previous">
          <v-icon> mdi-chevron-left </v-icon>
          {{ $t("vehicle_entry.back") }}
        </v-btn>
        <v-btn variant="outlined" color="primary" @click="next">
          {{ $t("settings.nextPage") }}
          <v-icon> mdi-chevron-right </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Toolbar from "@/components/Settings/toolbar.vue";
import General from "@/components/Settings/general.vue";
import Products from "@/components/Settings/products.vue";
import WhatsApp from "@/components/Settings/whatsapp.vue";
import Payment from "@/components/Settings/payment.vue";
import Plates from "@/components/Settings/plates.vue";
import OptIn from "@/components/Settings/optIn.vue";
import TwoFactorAuth from "@/components/Settings/twoFactorAuth.vue";
import WhatsappSettings from "@/components/Settings/WhatsApp/WhatsappSettings.vue";

import getRequest from "../api/getRequest";
import postRequest from "../api/postRequest";

export default {
  name: "Settings",
  components: {
    toolbar: Toolbar,
    general: General,
    products: Products,
    whatsapp: WhatsApp,
    payment: Payment,
    plates: Plates,
    optIn: OptIn,
    twoFactorAuth: TwoFactorAuth,
    'whatsapp-settings': WhatsappSettings,
  },
  data() {
    return {
      active: null,
      loading: false,
      loadingSave: false,
      institution: null,
    };
  },
  computed: {
    showWhatsappBusinessTab() {
      return this.$store.getters.role === "SuperAdmin";
    },
    visibleTabs() {
      const tabs = [
        { title: this.$t("settings.general"), value: "general" },
        { title: this.$t("settings.products"), value: "products" },
        {
          title: this.$t("settings.whatsAppChatBotLegacy"),
          value: "whatsAppChatBot",
        },
        { title: this.$t("settings.payments"), value: "payments" },
        { title: this.$t("settings.plates"), value: "plates" },
        { title: this.$t("settings.optIn"), value: "optIn" },
        { title: this.$t("settings.twoFactorAuth"), value: "twoFactorAuth" },
      ];
      if (this.showWhatsappBusinessTab) {
        tabs.splice(3, 0, {
          title: this.$t("settings.whatsappBusiness"),
          value: "whatsappBusiness",
        });
      }
      return tabs;
    },
  },
  beforeMount() {
    this.getInstitution();
  },
  methods: {
    next() {
      const currentIndex = this.visibleTabs.findIndex(
        (tab) => tab.value === this.active,
      );
      const nextIndex = (currentIndex + 1) % this.visibleTabs.length;
      this.active = this.visibleTabs[nextIndex].value;
    },

    previous() {
      const currentIndex = this.visibleTabs.findIndex(
        (tab) => tab.value === this.active,
      );
      const prevIndex =
        (currentIndex - 1 + this.visibleTabs.length) % this.visibleTabs.length;
      this.active = this.visibleTabs[prevIndex].value;
    },
    getInstitution() {
      this.loading = true;
      getRequest("/institution", `id=${this.$store.getters.institutionId}`)
        .then((response) => {
          [this.institution] = response.institution;
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      this.loadingSave = true;
      const formData = new FormData();

      const generalTab = Array.isArray(this.$refs.generalTab)
        ? this.$refs.generalTab[0]
        : this.$refs.generalTab;
      if (generalTab && generalTab.logo) {
        formData.append(
          "logo",
          generalTab.logo.blob,
          `logo.${generalTab.logo.extension}`,
        );
      }
      formData.append("institution", JSON.stringify(this.institution));
      postRequest
        .formData("/institution/edit", `id=${this.institution._id}`, formData)
        .then(() => {
          this.getInstitution();
          this.$store.dispatch(
            "institutionDisplayFeaturesAction",
            this.institution.preferences.displayFeatures,
          );
        })
        .catch(() => {})
        .finally(() => {
          this.loadingSave = false;
        });
    },
  },
};
</script>
